export function MobileContactBar({ phone, onRequestShowing, hidden }) {
  if (hidden || (!phone && !onRequestShowing)) return null;
  return (
    <div data-testid="listing-mobile-contact-bar" className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-[#111820] border-t border-white/10 px-3 pt-2.5 flex items-center gap-2"
      style={{ paddingBottom: "calc(0.625rem + env(safe-area-inset-bottom))" }}>
      {phone && <a data-testid="mobile-bar-call-btn" href={`tel:${phone}`} className="flex-1 text-center rounded-full border border-white/25 text-white text-sm font-medium py-2.5">Call Agent</a>}
      <button data-testid="mobile-bar-showing-btn" onClick={onRequestShowing} className="flex-1 rounded-full bg-[#C7A361] text-[#111820] text-sm font-medium py-2.5">Request Showing</button>
    </div>
  );
}
